var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFhLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 36,
    viewBox: "0 0 27 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1284 5.33898C21.5688 1.9323 17.654 0 13.4381 0C9.2222 0 5.30744 1.9323 2.74779 5.33898C-0.915929 10.2203 -0.915929 16.983 2.74779 21.8644L13.4381 36L24.1284 21.8644C27.7921 16.983 27.7921 10.2203 24.1284 5.33898V5.33898ZM13.4381 6.15244C17.3028 6.15244 20.4646 9.35583 20.4646 13.2711C20.4646 17.1863 17.3027 20.3897 13.4381 20.3897C9.57352 20.3897 6.4116 17.1863 6.4116 13.2711C6.4116 9.35583 9.57352 6.15244 13.4381 6.15244Z",
    fill: "#135478"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFhLocation);
export default __webpack_public_path__ + "static/media/ic_fh_location.de60d0bc78247e9e469bc1e4e86d389a.svg";
export { ForwardRef as ReactComponent };